import React, { useContext } from "react";
import { Outlet, Navigate } from "react-router-dom";
import AuthContext from "../context/AuthContext";

const AnonymousRoutes = () => {
    const { userDetails } = useContext(AuthContext)
    return (
        userDetails ? <Navigate to="/appointment"/> : <Outlet />
    )
};

export default AnonymousRoutes;
